import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionReplace from 'react-css-transition-replace';

import Immutable from 'seamless-immutable';
import { LoadingIndicator, ProgressBar, Tile, Button } from '../../components';
import theme from '../../app.theme';
import { ThemeColors } from '../../theme';
import Question from '../test/question';
import Answer from '../test/answer';


const INITIAL_STATE = {
  questionIndex: 0,
  progress: 0,
  selectedAnswers: Immutable({}),
};

class Test extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    if (this.props.test) return;

    if (!this.props.test) {
      if (this.props.match.params.testId) {
        this.props.loadTest({ id: this.props.match.params.testId });
      }

      if (this.props.match.params.resultId) {
        this.props.loadResult({ id: this.props.match.params.resultId });
      }
    }
  }

  loadTest(test) {
    test = test || this.props.test;
    const id = test.testId || test.id;
    this.props.history.push(`/tests/${id}`);
    this.props.loadTest({ id });
  }

  renderExplanation() {
    if (this.props.match.params.resultId) {
      return (
        <div style={{ marginTop: 25, paddingLeft: 22 }} className="breakBefore">
          <Answer
            small answer={{ text: 'Richtig beantwortet', isValidAnswer: true, answeredCorrectly: true }}
            completed={this.props.completed}
          />
          <Answer
            small answer={{ text: 'Richtige Antwort, nicht ausgewählt', isValidAnswer: true }}
            completed={this.props.completed}
          />
          <Answer
            small answer={{ text: 'Falsch ausgewählt' }}
            completed={this.props.completed}
          />
        </div>);
    }
  }


  renderContent() {
    const questions = this.props.questions.map(q =>
      <div className="card">
        <Question
          key={q.id}
          question={q}
          completed={this.props.completed}
          showAll
        />
      </div>);


    return (
      <div>
        <div className="col-sm-12 col-md-8 col-lg-6 col-lg-offset-1" style={{ marginBottom: '40px' }}>
          {questions}
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4">
          {this.renderExplanation()}
        </div>

      </div>
    );
  }

  render() {
    if (this.props.isLoading) {
      return <LoadingIndicator show centered />;
    }

    if (!this.props.test) {
      return null;
    }

    return (
      <div>
        <div className="col-md-12 col-lg-10 col-lg-offset-1">
          <div style={{ paddingLeft: '5px' }}>
            <h1 style={{ color: ThemeColors.accent2Color }}>{this.props.test.name || this.props.test.testName}</h1>
          </div>
          <div style={{ marginBottom: 20 }} />
        </div>
        {this.renderContent()}
      </div>
    );
  }
}


export default Test;



// WEBPACK FOOTER //
// ./src/app/main/test-all/test.js